export enum ReportType {
  ALL = 'ALL',
  GLOBAL_THEORETICAL_AND_REALISED = 'GLOBAL_REPORT_THEORETICAL_AND_REALISED',
  GLOBAL_PRODUCTION_AND_EXPEDITION = 'GLOBAL_REPORT_PRODUCTION_AND_EXPEDITION',
  GLOBAL_REPORT_RESULT_AND_MATERIAL = 'GLOBAL_REPORT_RESULT_AND_MATERIAL',
  GLOBAL_REPORT_CUMULATED_MATERIAL_RESULT = 'GLOBAL_REPORT_CUMULATED_MATERIAL_RESULT',
  GLOBAL_REPORT_CONDITIONED_STOCK = 'GLOBAL_REPORT_CONDITIONED_STOCK',
  CUMULATED_MONTHLY_REPORT_EXPORTER = 'CUMULATED_MONTHLY_REPORT_EXPORTER',
  CLIENT = 'CLIENT',
  CHARACTERIZATION_AVERAGE = 'CHARACTERIZATION_AVERAGE',
  CUMULATED_PASSAGE_CHAINE = 'CUMULATED_PASSAGE_CHAINE',
  STOCKS_AMONTS_FINAUX = 'STOCKS_AMONTS_FINAUX',
  DISTRIBUTION_KEYS = 'DISTRIBUTION_KEYS',
}

export enum ReportDownloadStatus {
  INITIAL = 'inital',
  PENDING = 'pending',
  SUCCESS = 'success',
  NOT_PROCESSABLE = 'not processable',
  ERROR = 'error',
  INCOMING_SOON = 'incoming soon',
}
